import { useMemo } from "react";
import { BULK_COLUMNS, FAIL_COLUMNS } from "../constants/bulkUploadColumns";
import { VALIDATION_MAPPING } from "../constants/validationMapping";

const MESSAGES = {
    ORDERS: "Orders bulk file uploaded successfully",
    OUTSOURCE: "Outsources bulk file uploaded successfully",
    CLIENT: "Clients bulk file uploaded successfully",
    STAFF: "Staff bulk file uploaded successfully",
    DRIVERS: "Drivers bulk file uploaded successfully",
    ITEMS: "Items bulk file uploaded successfully",
} as const;

export const useBulkConfig = (message?: string) => {
    console.log(message,'m')
    return useMemo(() => {
        let type: keyof typeof MESSAGES | null = null;
        for (const [k, v] of Object.entries(MESSAGES)) {
            if (message === v) type = k as keyof typeof MESSAGES;
        }
        console.log(type,'t')
        const allColumns = type ? BULK_COLUMNS[type] : BULK_COLUMNS.OUTSOURCE;
        const failColumns = type ? FAIL_COLUMNS[type] : FAIL_COLUMNS.OUTSOURCE;
        const validationMessages = allColumns.map(c => VALIDATION_MAPPING[c.key] ?? c.key);
        console.log(allColumns,'a', failColumns,'f')
        return { allColumns, failColumns, validationMessages };
    }, [message]);
};